// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-94246a62],html[data-v-94246a62]{scroll-behavior:smooth}", ""]);
// Exports
module.exports = exports;
